import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ProjectOutlined,
  TeamOutlined,
  ScheduleOutlined,
  CheckCircleOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  plan: <ProjectOutlined />,
  assign: <TeamOutlined />,
  track: <ScheduleOutlined />,
  deliver: <CheckCircleOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("pm");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-pm-workflow-grid",
        isCompact ? "dev-pm-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-pm-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-pm-step-item">
                <div className={`dev-pm-step-card dev-pm-step-card--${step.key}`}>
                  <div className="dev-pm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-pm-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-pm-step-card dev-pm-step-card--${step.key}`}>
                <div className="dev-pm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-pm-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-pm-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
